export const formatColor = (x) => {
    const r = (x >> 16) & 255;
    const g = (x >> 8) & 255;
    const b = x & 255;
    return `rgb(${r}, ${g}, ${b})`;
};